export const getFileUrl = (id: number ): string => {
    return `/brightside/files/${id}`;
};

export const downloadFile = (url: string): void => {
    const link = document.createElement('a');
    link.href = url;
    link.download = "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};